// extracted by mini-css-extract-plugin
export default {"Circle2":"Circle2_Circle2__bkYTe"};